import React from 'react';
import { useSelector } from 'react-redux';
import { EnvironmentOutlined } from '@ant-design/icons';
import { TbPlane } from 'react-icons/tb';
import { RootState } from '../../../../store/store';
import {
  fillTemplate,
  getAirportDistanceLevel,
} from '../../../../utils/arrivalAirport';
import '../../../../components/ArrivalAirport/arrivalAirport.less';

// "(TLV) Tel Aviv" — with only one of the two known (e.g. an airport restored
// from the URL by its code) just that one, never "(undefined)".
const airportText = (code?: string, name?: string) => {
  if (code && name) return `(${code}) ${name}`;
  return code || name || '';
};

export const AirportElement = ({
  data,
  distanceKm,
}: {
  data: any;
  /** km from the hotel (hotel + flight pages only). */
  distanceKm?: number | null;
}) => {
  const arrivalAirportT = useSelector(
    (state: RootState) => state.config.translations?.arrivalAirport
  );
  const hasDistance =
    distanceKm !== null && distanceKm !== undefined && !!arrivalAirportT;
  return (
    <div
      className={`auto-complete-airport-element ${
        data?.type === 'airport' ? 'indented' : ''
      }`}
    >
      <div className="type-icon-wrapper">
        {data?.type === 'city' && <EnvironmentOutlined />}
        {data?.type === 'airport' && <TbPlane />}
      </div>
      <div className="element-info-wrapper">
        <span className="name">
          {airportText(data?.iata_code, data?.name)}
        </span>
        {data.country && <span className="description">{data.country}</span>}
        {hasDistance && (
          <span
            className={`distance airport-distance arrival-airport-level-${getAirportDistanceLevel(
              distanceKm
            )}`}
          >
            {fillTemplate(arrivalAirportT.kmFromHotel, { km: distanceKm })}
          </span>
        )}
      </div>
    </div>
  );
};
